<template>
  <div>
    <div v-for="(item,index) in chart19_data_option" :key="'1'+index" class="marginTop">
      <div class="box15_bottom_top">
        <div class="box15_bottom_top_text"><img src="../../../../public/img/shares_Info/1.png" alt="" /></div>
        <div class="box15_bottom_top_title">{{item.name}}</div>
      </div>
      <div class="box11_top_legend_box">
        <div class="box11_top_legend_box_option1"><div class="box11_top_legend_box_option2_colordiv"></div>营收占比</div>
        <div class="box11_top_legend_box_option1"><div class="box11_top_legend_box_option1_colordiv"></div>毛利率</div>
      </div>
      <echarts :width="'100%'" :height="'180px'" :chartData="item.option"></echarts>
      <div class="chart19_table">
        <table border="1" cellspacing="0">
          <tr><th v-for="(item, index) in item.table" :key="'2' + index">{{ item.data1 }}</th></tr>
          <tr><td v-for="(item, index) in item.table" :key="'3' + index">{{ item.data2 }}</td></tr>
          <tr class="tr3"><td v-for="(item, index) in item.table" :key="'4' + index">{{ item.data3 }}</td></tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from '../../../components/echarts.vue'
export default {
  props:{
    chart19_data_option:{
      type:Array,
      default(){
        return []
      }
    }
  },
  components:{
    echarts,
  },
  data() {
    return {
    }
  },
  methods: {
    
  },
  mounted() {
    
  },
};
</script>

<style scoped>
.chart4_table {
  margin-top: 50px;
}
table {
  border-color: #e9ebf3;
  border-collapse: collapse;
}
th,
td {
  width: 288px;
  height: 36px;
  line-height: 36px;
  text-align: center;
}
th {
  font-size: 14px;
  color: #666666;
  font-weight: 400;
}
td {
  font-size: 14px;
  color: #fcad2a;
}
.tr3 td {
  color: #579eff;
}
.chart19_table{
  margin-top: 30px;
}
.box15_bottom_top {
  display: flex;
}
.box15_bottom_top_text img {
  width: 10px;
  height: 13px;
  margin-right: 3px;
}
.box15_bottom_top_title {
  /* width: 65px; */
  height: 16px;
  font-size: 16px;
  color: #333333;
  position: relative;
  z-index: 5;
}
.box15_bottom_top_title::after {
  content: "";
  display: block;
  width: 60px;
  height: 4px;
  background-image: linear-gradient(135deg, #f8c54a 0%, #fcad2a 100%),
    linear-gradient(#fd4c4c, #fd4c4c);
  background-blend-mode: normal, normal;
  box-shadow: 0px 4px 16px 2px rgba(252, 173, 42, 0.13);
  border-radius: 1px;
  overflow: hidden;
  margin: 0 auto;
  position: absolute;
  bottom: -4px;
  left: calc(50% - 30px);
  z-index: -4;
}
.box11_top_legend_box {
  display: flex;
  margin-top: 20px;
}
.box11_top_legend_box_option1 {
  display: flex;
  align-content: center;
  font-size: 14px;
  line-height: 15px;
  color: #333333;
  margin-left: 15px;
  cursor: pointer;
}
.box11_top_legend_box_option1:nth-child(1) {
  margin-left: 0;
}
.box11_top_legend_box_option1_colordiv {
  background-color: #539cff;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.box11_top_legend_box_option2_colordiv {
  background-color: #fcad2a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  margin-top: 2.5px;
}
.marginTop{
  margin-top: 20px;
}
</style>